import { render } from "./WebMenuMessage.vue?vue&type=template&id=25acf1f0"
import script from "./WebMenuMessage.vue?vue&type=script&lang=js"
export * from "./WebMenuMessage.vue?vue&type=script&lang=js"

import "./WebMenuMessage.vue?vue&type=style&index=0&id=25acf1f0&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__